import type { Dimensions } from 'modules/org_chart/models/Dimensions'

export const NODE_SIZE: Dimensions = [236, 258]
